// ============================================================
// CareRotaRoleMappingsSection.jsx  (CareRota role model, 2026-07-14;
// on the shared ModuleRoleMappingsSection)
//
// Thin instantiation of the shared component — no tier (single access axis).
// Rota Coordinator / Rota Manager.
// ============================================================

import React from 'react';
import ModuleRoleMappingsSection from './ModuleRoleMappingsSection';
import {
  listCareRotaRoleMappings,
  createCareRotaRoleMapping,
  deleteCareRotaRoleMapping,
} from '../api/federation';

const ROLE_LABEL = { rota_coordinator: 'Rota Coordinator', rota_manager: 'Rota Manager' };

export default function CareRotaRoleMappingsSection({ clientId }) {
  return (
    <ModuleRoleMappingsSection
      clientId={clientId}
      testId="carerota-role-mappings"
      title="CareRota role mappings"
      descriptor="Map an AD group to a CareRota module role (Rota Coordinator / Rota Manager). Members are auto-granted on sign-in and the hourly reconcile; Rota Manager also carries CareRota settings write."
      roleField="careRotaRole"
      roleOptions={[{ value: 'rota_coordinator', label: 'Rota Coordinator' }, { value: 'rota_manager', label: 'Rota Manager' }]}
      emptyMessage="No CareRota role mappings configured yet."
      confirmTitle="Remove CareRota role mapping?"
      confirmMessage={(t) => `Members of "${t.groupDisplayName || t.groupObjectId}" will lose this ${ROLE_LABEL[t.careRotaRole] || t.careRotaRole} mapping at the next reconcile. Existing grants are not removed immediately.`}
      toastCreated="CareRota role mapping created."
      toastRemoved="CareRota role mapping removed."
      api={{ list: listCareRotaRoleMappings, create: createCareRotaRoleMapping, remove: deleteCareRotaRoleMapping }}
    />
  );
}
